let answers = [];

function clickAnswer() {
    const buttons = document.querySelectorAll('.ask-answer__actions .ask-answer__btn');
    if (buttons) {
        for (let i = 0; i < buttons.length; i++) {
          const item = buttons[i];
          item.addEventListener("click", function () {
            const nextKey = item.getAttribute('data-nextKey');
            const questionKey = item.getAttribute('data-questionKey');

            renderNextQuestion(nextKey, questionKey);

            toggleQuestions();
            toggleButtons();
            toggleActiveButtons();

            const questionBlock = document.getElementById('question-' + nextKey);
            const buttonsBlock = document.getElementById('buttons-' + nextKey);

            if (questionBlock){
                questionBlock.classList.remove('d-none');
            }

            if (buttonsBlock){
                buttonsBlock.classList.remove('d-none');
            }
            
            window.scrollTo(0, item.offsetTop - (item.offsetHeight * 2));

            item.classList.add('--is-active');
          });
        }
    }
}

function toggleActiveButtons() {
    // Remove all active buttons first
    const buttonsElement = document.querySelectorAll('[id^="buttons-"]');
    
    for (let index = 0; index < buttonsElement.length; index++) {
        const element = buttonsElement[index];
        
        if (element) {
            const buttons = element.getElementsByTagName('button');
            for (let index = 0; index < buttons.length; index++) {
                const buttonElement = buttons[index];
                buttonElement.classList.remove('--is-active');
            }
        }
    }

    for (let index = 0; index < answers.length; index++) {
        const element = answers[index];
        const buttons = document.getElementById('buttons-' + element['question']);

        if (buttons) {
            const questionButtons = buttons.getElementsByTagName('button');

            if (questionButtons) {
                for (let index = 0; index < questionButtons.length; index++) {
                    const buttonElement = questionButtons[index];
                    if (buttonElement.getAttribute('data-nextKey') === element['next']) {
                        buttonElement.classList.add('--is-active');
                    }
                }
            }
        }
    }
}

function toggleQuestions() {
    // Hide all questions first
    const questions = document.querySelectorAll('[id^="question-"]');

    if (questions) {
        for (let index = 0; index < questions.length; index++) {
            const element = questions[index];
            element.classList.add('d-none');
        }
    }

    for (let index = 0; index < answers.length; index++) {
        const element = answers[index];
        const questionElement = document.getElementById('question-' + element['question']);

        if (questionElement) {
            questionElement.classList.remove('d-none');
        }
    }
}

function toggleButtons() {
    // Hide all buttons first
    const buttons = document.querySelectorAll('[id^="buttons-"]');

    if (buttons) {
        for (let index = 0; index < buttons.length; index++) {
            const element = buttons[index];
            element.classList.add('d-none');
        }
    }

    for (let index = 0; index < answers.length; index++) {
        const element = answers[index];
        const buttonsElement = document.getElementById('buttons-' + element['question']);

        if (buttonsElement) {
            buttonsElement.classList.remove('d-none');
        }
    }
}

function renderNextQuestion(nextKey, questionKey) {
    var questionIndex = answers.findIndex(x => x.question === questionKey);

    if (questionIndex > -1) {
        while (answers.length > questionIndex) {
            answers.pop(answers[questionIndex]);
        }
    }

    const answer = {};
    answer['question'] = questionKey;
    answer['next'] = nextKey;

    answers.push(answer);
}

clickAnswer();